export enum FuelType {
    HYBRID = 'HYBRID',
    ELECTRIC = 'ELECTRIC',
    DIESEL = 'DIESEL',
    GAS = 'GAS'
}
